import ProductOfferMessage, { ProductOfferMessageProps } from './ProductOfferMessage'
export default ProductOfferMessage
export { ProductOfferMessage }
export type { ProductOfferMessageProps }
